(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eqt-serviceleiste"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eqt-service-bar')) {
    customElements.define('eqt-service-bar', class extends HTMLElement {
      connectedCallback() {
        if (this._events) return;
        this._events = new AbortController();
        this._button = this.querySelector('[data-copy]');
        this._fallback = this.querySelector('[data-fallback]');
        if (this._button && this._button.dataset.code) {
          this._button.hidden = false;
          if (this._fallback) this._fallback.hidden = true;
          this._button.addEventListener('click', () => this.copyCode(), { signal: this._events.signal });
        }
        this.addEventListener('keydown', (event) => {
          const details = this.querySelector('details[open]');
          if (event.key === 'Escape' && details) {
            details.open = false;
            details.querySelector('summary').focus();
          }
        }, { signal: this._events.signal });
      }

      disconnectedCallback() {
        this._events?.abort();
        this._events = null;
        clearTimeout(this._resetTimer);
        if (this._button) {
          this._button.querySelector('[data-copy-text]').textContent = this._button.dataset.code;
          this._button.setAttribute('aria-label', `Rabattcode ${this._button.dataset.code} kopieren`);
        }
      }

      legacyCopy(code) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.setAttribute('aria-label', 'Rabattcode zum Kopieren');
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
        this.append(field);
        field.select();
        field.setSelectionRange(0, code.length);
        let success = false;
        try { success = document.execCommand('copy'); } catch (_) { /* Manual copy remains available. */ }
        field.remove();
        this._button.focus({ preventScroll: true });
        return success;
      }

      async copyCode() {
        if (this._copying) return;
        this._copying = true;
        clearTimeout(this._resetTimer);
        const code = this._button.dataset.code;
        const label = this._button.querySelector('[data-copy-text]');
        const status = this.querySelector('[data-status]');
        const notice = this.querySelector('[data-notice]');
        let success = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
            success = true;
          } else {
            success = this.legacyCopy(code);
          }
        } catch (_) {
          if (this.isConnected) success = this.legacyCopy(code);
        } finally {
          this._copying = false;
        }
        if (!this.isConnected) return;
        if (success) {
          notice.hidden = true;
          this._fallback.hidden = true;
          label.textContent = 'Kopiert';
          this._button.setAttribute('aria-label', `Rabattcode ${code} kopiert`);
          status.textContent = `Rabattcode ${code} kopiert. Im Checkout einfügen.`;
          this._resetTimer = setTimeout(() => {
            label.textContent = code;
            this._button.setAttribute('aria-label', `Rabattcode ${code} kopieren`);
            status.textContent = '';
          }, 2200);
        } else {
          label.textContent = code;
          this._button.setAttribute('aria-label', `Rabattcode ${code} kopieren`);
          this._fallback.hidden = false;
          this._fallback.textContent = code;
          notice.textContent = `Bitte den Code ${code} markieren, kopieren und im Checkout einfügen.`;
          notice.hidden = false;
          status.textContent = notice.textContent;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
